import { BUCKET_DESTINATION } from '../config'
import { getPlayerId } from '../controllers/stats'
import isDevEnvironment from './isDevEnvironment'

async function setupEngagementTimer() {
	// Add "egg-timer" (engagement timer) to page
	// ------------------------------------------
	const playerId = getPlayerId()
	const playerQuota = 10 // % of players to track
	const testPlayerId = 'c4c1e568-c5ba-4b8f-88cf-ff728299ced6'

	if (isDevEnvironment() || Math.random() < playerQuota / 100 || playerId === testPlayerId) {
		// Determine basepath to remove from URLs (e.g. /onewordsearch or /onewordsearch_c87654ed etc.)
		let basepath = (BUCKET_DESTINATION || '').split('.com')[1]
		if (basepath.endsWith('/')) basepath = basepath.slice(0, -1)

		const script = document.createElement('script')
		script.src = 'https://static.waffleclub.com/lib/egg-timer.umd.js'
		script.src += `?pid=${playerId}` // Player ID for tracking
		script.src += '&game=ows_classic_web' // Game ID - one word search, classic web version
		script.src += `&basepath=${basepath}` // Basepath to remove
		script.src += isDevEnvironment() ? '&debug=true' : '' // Enable debug mode in dev
		script.src += isDevEnvironment() ? `&v=${Date.now()}` : '' // Prevent caching in dev
		script.async = true
		document.head.appendChild(script)
	}
}

export default setupEngagementTimer
